export default __webpack_public_path__ + "static/media/download.b2904648.svg";